/*
 *
 * ChooseFileDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 15-May-2025
*/

import ChooseFileDialog from './ChooseFileDialogContainer'

export default ChooseFileDialog
